import { useState } from 'react';
import MediaGallery from 'src/components/MediaGallery';
import MediaCarousel from 'src/components/MediaGallery/MediaCarousel';
import { buildImageUrl } from 'src/util/buildImageUrl';
import getAttachemntType from 'src/components/MediaGallery/getAttachmentType';

const attachments = [
  {
    id: 6,
    postId: 3,
    attachmentLocationId: 1,
    attachmentTypeId: 3,
    attachmentUrl: 'uploads/mock/stars.webp',
    size: 1836647,
    createdAt: '2023-06-12T20:01:02.394Z',
    updatedAt: '2023-06-12T20:01:02.394Z',
    originalFileName: 'stars.webp',
    thumbnail: `https://peach.blender.org/wp-content/uploads/title_anouncement.jpg?x11217`,
    caption: 'this is some big caption',
  },
  {
    id: 7,
    postId: 3,
    attachmentLocationId: 1,
    attachmentTypeId: 1,
    attachmentUrl: 'uploads/mock/dummy.pdf',
    size: 1836647,
    createdAt: '2023-06-12T20:01:02.394Z',
    updatedAt: '2023-06-12T20:01:02.394Z',
    originalFileName: 'dummy.pdf',
  },
  {
    id: 6,
    postId: 3,
    attachmentLocationId: 1,
    attachmentTypeId: 3,
    attachmentUrl: 'uploads/mock/wolf.webp',
    size: 1836647,
    createdAt: '2023-06-12T20:01:02.394Z',
    updatedAt: '2023-06-12T20:01:02.394Z',
    originalFileName: 'wolf.webp',
    thumbnail: `https://peach.blender.org/wp-content/uploads/title_anouncement.jpg?x11217`,
    caption: 'caption is here',
  },
  {
    id: 8,
    postId: 3,
    attachmentLocationId: 1,
    attachmentTypeId: 2,
    attachmentUrl: 'uploads/mock/ElephantsDream.mp4',
    size: 1836647,
    createdAt: '2023-06-12T20:01:02.394Z',
    updatedAt: '2023-06-12T20:01:02.394Z',
    originalFileName: 'ElephantsDream.mp4',
  },
];

const Playground = () => {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [index, setindex] = useState(0);

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  const media = attachments.map((attachment) => {
    return {
      primary: false,
      type: getAttachemntType(attachment.attachmentTypeId),
      src: attachment.attachmentUrl,
      thumbnail: attachment.thumbnail,
      attachmentUrl: attachment.attachmentUrl,
      originalFileName: attachment.originalFileName,
      caption: attachment.caption,
    };
  });

  return (
    <>
      <div className="container mx-auto px-5 py-2 lg:px-32 lg:pt-12">
        <MediaGallery
          media={media}
          onItemClick={(mediaItemIndex) => {
            setindex(mediaItemIndex);
            setViewerOpen(true);
          }}
        />
        {viewerOpen && (
          <MediaCarousel media={media} onClose={handleCloseViewer} initIndex={index} />
        )}
      </div>
    </>
  );
};

export default Playground;
